import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, Grid } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'

@Component({
    templateUrl: './employee-assets.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        FormsModule,
        ActionToolbarCount,
        ActionToolbarSearchComponent,
        GridExportComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class EmployeeAssetsComponent extends BaseComponent {
    faSearch = faSearch
    grid: Grid<any>

    active = 1

    allAssigned: any[] = []
    unassigned: any[] = []

    constructor() {
        super()

        this.grid = new Grid<any>(this.services)
            .wrapColumnHeaders()
            .filterBy(item => [
                item.asset,
                item.employeeName,
                item.truck,
                item.assetDesc,
                item.assetCategory,
                item.uddevicename,
                item.identifier,
            ])

        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.get('api/EmployeeAssets/GetAssets')).subscribe({
                next: result => {
                    this.initialLoadingComplete()
                    this.allAssigned = result[0].employeeAssigned
                    this.unassigned = result[0].unassigned
                    this.grid.items = this.allAssigned
                },
            }),
        )
    }

    tabChanged() {
        if (this.active === 1) {
            this.grid.items = this.allAssigned
        }
        if (this.active === 2) {
            this.grid.items = this.unassigned
        }
    }
}
